const templateUrl = require('./views/send-shipment-now-dialog.html');

const inject = ['$state', '$translate', 'shipmentOrchestrator', 'dialogService', 'toastService'];
function SendShipmentNowControllerFactory($state, $translate, shipmentOrchestrator, dialogService, toastService) {
  class SendShipmentNowController {
    sendShipmentNow(shipment) {
      return dialogService.open({
        templateUrl: templateUrl,
        confirmText: $translate.instant('MODAL_SEND_NOW_SAVE'),
        onSuccess: () => shipmentOrchestrator.sendShipmentNow(shipment.publicId)
          .then(() => toastService.translate.success('TOAST_SEND_NOW_SUCCESS'))
          .then($state.reload)
          .catch(() => toastService.translate.danger('TOAST_SEND_NOW_DANGER')),
        windowTopClass: 'og-send-shipment-now-modal',
        ariaLabelledBy: 'og-send-asap-modal-title',
        ariaDescribedBy: 'og-send-asap-modal-description'
      }).result;
    }
  }
  return new SendShipmentNowController();
}

SendShipmentNowControllerFactory.$inject = inject;

const app = angular.module('msi.shipments.sendShipmentNow.controller', []);

app.controller('SendShipmentNowController', SendShipmentNowControllerFactory);

module.exports = app.name;
